module.exports = window.__appConfig__
